import { Box } from "@mui/material";
import { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  DemanderKbn,
  FormClassRetire,
  FormKbn,
  FormStatus,
  Status,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkStepper from "../../components/atoms/TkStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { fakeTableList, heirStepper, retireeStepper, schema } from "./parts";
import { TkRouteContext } from "../../context/tkRouteContext";
import { httpIAPI_STA040 } from "./api/request";
import _ from "lodash";
import { FileList } from "../../type/contextType/businessContext/IJob_35";

/**
 * SCRR411112 退職手当金の請求手続き（退職所得の源泉徴収票登録）
 * 退職手当金請求者が福祉医療機構以外の退職手当金に係る源泉徴収票を登録する。
 * @return SCRR411112
 */
const SCRR411112 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const { state: routerState } = useContext(TkRouteContext);
  const [stateTableList, setStateTableList] = useState<any>([]);
  const [activeStep, setActiveStep] = useState<number>(6);
  const [stepper, setStepper] = useState<any>(retireeStepper);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const context = businessState.job_35;
  const type = context?.editPage; // 編集枚目
  let formClass = "";
  const demanderKbn = context?.demanderKbn;
  const editPage = context?.retirementEditPage;
  const fileClass = {
    "1": FormClassRetire["退職所得の源泉徴収票_退職届1枚目"],
    "2": FormClassRetire["退職所得の源泉徴収票_退職届2枚目"],
    "3": FormClassRetire["退職所得の源泉徴収票_退職届3枚目"],
  }[editPage ?? ""];

  if (editPage) {
    formClass = fileClass ?? "";
  } else {
    formClass =
      type === "1"
        ? FormClassRetire["退職所得の源泉徴収票_手当金請求1枚目"]
        : FormClassRetire["退職所得の源泉徴収票_手当金請求2枚目"];
  }

  // 遷移元
  let comeForm: any = "";

  if (routerState.routerList && routerState.routerList.length >= 2) {
    comeForm = routerState.routerList[routerState.routerList.length - 2].href;
  }

  // 初期表示
  useEffect(() => {
    if (demanderKbn === DemanderKbn["相続人"]) {
      // 一時保存ステップ
      setActiveStep(7);
      setStepper(heirStepper);
    }
    let resArr = [...stateFakeTableList.current];

    if (comeForm === "/SCRW410001" && editPage) {
      // 持回り情報の初期表示
      for (let i in context) {
        let targetObjByType = resArr.find((item) => {
          return `retirementPage${editPage}${item.keyword}` === i;
        })!;

        let targetObj = resArr.find((item) => item.keyword === i)!;
        targetObjByType &&
          (targetObjByType.setDefaultValue = (
            businessState as { [key: string]: any }
          ).job_35[i]);

        targetObj &&
          (targetObj.setDefaultValue = (
            businessState as { [key: string]: any }
          ).job_35[i]);

        //退職所得の源泉徴収票
        if (i === "retirementFileList" && context[i] !== undefined) {
          let fileList = resArr.find(
            (item) => item.keyword === "withholdingFile"
          )!;
          const oldFileListTmp = context[i]?.filter((itm: any) => {
            return itm.formClass === fileClass;
          });
          // setOldFileList(oldFileListTmp);
          fileList.setDefaultValue =
            oldFileListTmp?.map((file: any) => {
              return {
                formName: file.fileName ?? file?.formName,
                fileBase64: file.file ?? file?.fileBase64,
              };
            }) ?? [];
        }
      }
    } else {
      // 持回り情報の初期表示
      for (let i in context) {
        let targetObjByType = resArr.find(
          (item) => `page${type}${item.keyword}` === i
        )!;
        let targetObj = resArr.find((item) => item.keyword === i)!;
        targetObjByType &&
          (targetObjByType.setDefaultValue = (
            businessState as { [key: string]: any }
          ).job_35[i]);

        targetObj &&
          (targetObj.setDefaultValue = (
            businessState as { [key: string]: any }
          ).job_35[i]);

        //退職所得の源泉徴収票
        if (i === "fileList" && context[i] !== undefined) {
          let fileList = resArr.find(
            (item) => item.keyword === "withholdingFile"
          )!;
          const oldFileListTmp = context[i]?.filter(
            (itm: any) => itm.formClass === formClass
          );

          fileList.setDefaultValue =
            oldFileListTmp?.map((file: any) => {
              return {
                formName: file.fileName ?? file.formName,
                fileBase64: file.file ?? file?.fileBase64,
              };
            }) ?? [];
        }
      }
    }

    resArr.find(
      (item) => item.keyword === "deductionPeriodYear"
    )!.setDefaultValue = !!type
      ? context?.[`page${type}DeductionPeriodYear` as keyof typeof context]
      : context?.[
          `retirementPage${editPage}DeductionPeriodYear` as keyof typeof context
        ];
    resArr.find(
      (item) => item.keyword === "deductionPeriodMonth"
    )!.setDefaultValue = !!type
      ? context?.[`page${type}DeductionPeriodMonth` as keyof typeof context]
      : context?.[
          `retirementPage${editPage}DeductionPeriodMonth` as keyof typeof context
        ];

    // ユーザタイプが機構の場合
    if (state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO) {
      let retireeName = resArr.find((item) => item.keyword === "retireeName")!;
      let duplicationLosYear = resArr.find(
        (item) => item.keyword === "duplicationLosYear"
      )!;
      let duplicationLos = resArr.find(
        (item) => item.keyword === "duplicationLos"
      )!;

      // 行の表示
      // 退職者名の表示
      retireeName.contractorNumber = context?.retirementStaffName;
      retireeName.showLine = true;
      if (type) {
        //重複勤続年数
        duplicationLosYear.showLine = true;
        //重複期間
        duplicationLos.start = {
          wantToSetValue: context?.duplicationLosFrom,
        };
        duplicationLos.end = {
          wantToSetValue: context?.duplicationLosTo,
        };
        duplicationLos.showLine = true;
        duplicationLosYear.setDefaultValue = context?.duplicationLosYear;
        duplicationLos.start.wantToSetValue = context?.duplicationLosFrom;
        duplicationLos.end.wantToSetValue = context?.duplicationLosTo;
      }
    }
    setStateTableList(resArr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editPage, comeForm]);

  const getFileList = (data: any) => {
    const sourceList: any[] = editPage
      ? context?.retirementFileList ?? []
      : context?.fileList ?? [];

    const fileIndex = sourceList.findIndex((item: any) => {
      return item.formClass === formClass;
    });

    const nowFile = fileIndex >= 0 ? sourceList[fileIndex] : undefined;

    const fileObj = {
      serialNo: nowFile?.serialNo ?? (fileIndex >= 0 ? fileIndex + 1 : 1),
      staffNo: context?.staffNo,
      formKbn: FormKbn["退職書類"],
      formClass,
      fileName: data.formName,
      fileBase64: data.fileBase64,
      facilityNo: nowFile?.facilityNo ?? null,
      issueDocumentNo: nowFile?.issueDocumentNo ?? null,
      issueDate: nowFile?.issueDate ?? null,
      formStatus: nowFile?.formStatus ?? FormStatus["登録済"],
    };

    const nextFileList = [...sourceList];
    if (fileIndex >= 0) {
      nextFileList.splice(fileIndex, 1, fileObj);
    } else {
      nextFileList.push(fileObj);
    }

    return nextFileList.map((item: any) => {
      const { fileList_staffNo, ...rest } = item;

      return {
        ...rest,
        staffNo: fileList_staffNo ?? item.staffNo,
        fileName: item.formName ?? item.fileName,
      };
    });
  };

  const handleSubmit = async (data: any, index: any) => {
    switch (index) {
      case 0: // 登録
        // 業務チェック
        if (
          data.RetiredDate < context?.first_join_date! ||
          data.EmployedDate > context?.retireDate!
        ) {
          setState({
            ...state,
            errorMsgId: "TKMSG_SCR0125E",
          });
          return;
        }

        setState({
          ...state,
          errorMsgId: "",
        });

        let comeForm: any = "";

        if (routerState.routerList && routerState.routerList.length >= 2) {
          comeForm =
            routerState.routerList[routerState.routerList.length - 2].href;
        }

        // 法人が添付した源泉徴収票
        if (editPage && comeForm === "/SCRW410001") {
          const currentFileList = getFileList(data.withholdingFile[0]);

          const newJob = {
            ...context,
            [`retirementPage${editPage}EmployedDate`]: data.EmployedDate,
            [`retirementPage${editPage}RetiredDate`]: data.RetiredDate,
            [`retirementPage${editPage}Kbn`]: data.Kbn,
            [`retirementPage${editPage}PaymentAmt`]: data.PaymentAmt,
            [`retirementPage${editPage}WithholdingAmt`]: data.WithholdingAmt,
            [`retirementPage${editPage}ScAmtCity`]: data.ScAmtCity,
            [`retirementPage${editPage}ScAmtPrefecture`]: data.ScAmtPrefecture,
            [`retirementPage${editPage}LengthOfService`]: data.LengthOfService,
            [`retirementPage${editPage}DeductionPeriodYear`]:
              data.deductionPeriodYear,
            [`retirementPage${editPage}DeductionPeriodMonth`]:
              data.deductionPeriodMonth,
            retirementFileList: currentFileList,
          };

          setBusinessState({
            ...businessState,
            job_35: {
              ...newJob,
              fileList: currentFileList.map((file: any) => {
                return {
                  ...file,
                  fileList_staffNo: file.staffNo,
                  fileBase64: file.fileBase64,
                  fileName: file.fileName,
                };
              }),
            },
          });

          try {
            const res = await httpIAPI_STA040({
              applyId: context?.retirementFormApplyId,
              formProspectNum: +(context?.retirementEditPage ?? 1),
              [`page${editPage}EmployedDate`]: data.EmployedDate,
              [`page${editPage}RetiredDate`]: data.RetiredDate,
              [`page${editPage}Kbn`]: data.Kbn,
              [`page${editPage}PaymentAmt`]: data.PaymentAmt,
              [`page${editPage}WithholdingAmt`]: data.WithholdingAmt,
              [`page${editPage}ScAmtCity`]: data.ScAmtCity,
              [`page${editPage}ScAmtPrefecture`]: data.ScAmtPrefecture,
              [`page${editPage}LengthOfService`]: data.LengthOfService,
              [`page${editPage}DeductionPeriodYear`]:
                data.deductionPeriodYear !== ""
                  ? data.deductionPeriodYear
                  : null,
              [`page${editPage}DeductionPeriodMonth`]:
                data.deductionPeriodMonth !== ""
                  ? data.deductionPeriodMonth
                  : null,
              formList: currentFileList,
              screenId: "SCRR411112",
              latestApplyStatus: Status["処理完了"],
            });

            if (res.resultCd === "I0000") {
              setState({
                ...state,
                errorMsgId: "",
              });

              if (
                routerState.routerList &&
                routerState.routerList.length >= 2
              ) {
                navigate(
                  "" +
                    routerState.routerList[routerState.routerList.length - 2]
                      .href
                );
              } else {
                navigate("/");
              }
            } else {
              setState({
                ...state,
                errorMsgId: res.resultCd,
              });
            }
          } catch (error) {
            navigate("/error");
          }
        } else {
          // 退職所得の源泉徴収票
          const currentFileList = getFileList(data.withholdingFile[0]);

          const newJob = {
            ...context,
            formProspectNum: 1,
            [`page${type}EmployedDate`]: data.EmployedDate,
            [`page${type}RetiredDate`]: data.RetiredDate,
            [`page${type}Kbn`]: data.Kbn,
            [`page${type}PaymentAmt`]: data.PaymentAmt,
            [`page${type}WithholdingAmt`]: data.WithholdingAmt,
            [`page${type}ScAmtCity`]: data.ScAmtCity,
            [`page${type}ScAmtPrefecture`]: data.ScAmtPrefecture,
            [`page${type}LengthOfService`]: data.LengthOfService,
            [`page${type}DeductionPeriodYear`]:
              data.deductionPeriodYear !== "" ? data.deductionPeriodYear : null,
            [`page${type}DeductionPeriodMonth`]:
              data.deductionPeriodMonth !== ""
                ? data.deductionPeriodMonth
                : null,
            duplicationLosYear: data.duplicationLosYear,
            duplicationLosFrom: data.duplicationLos?.startDate,
            duplicationLosTo: data.duplicationLos?.endDate,
            fileList: currentFileList,
          };

          setBusinessState({
            ...businessState,
            job_35: {
              ...context,
              ...newJob,
              fileList: currentFileList.map((file: any) => {
                return {
                  ...file,
                  fileList_staffNo: file.staffNo,
                  fileBase64: !file?.fileBase64 ? file?.file : file?.fileBase64,
                  formName: file.fileName,
                };
              }),
            },
          });

          if (comeForm === "/SCRW410001") {
            try {
              // 源泉徴収票更新API
              const res = await httpIAPI_STA040({
                applyId: context?.applyId,
                formProspectNum: 1,
                [`page${type}EmployedDate`]: data.EmployedDate,
                [`page${type}RetiredDate`]: data.RetiredDate,
                [`page${type}Kbn`]: data.Kbn,
                [`page${type}PaymentAmt`]: data.PaymentAmt,
                [`page${type}WithholdingAmt`]: data.WithholdingAmt,
                [`page${type}ScAmtCity`]: data.ScAmtCity,
                [`page${type}ScAmtPrefecture`]: data.ScAmtPrefecture,
                [`page${type}LengthOfService`]: data.LengthOfService,
                [`page${type}DeductionPeriodYear`]:
                  data.deductionPeriodYear !== ""
                    ? data.deductionPeriodYear
                    : null,
                [`page${type}DeductionPeriodMonth`]:
                  data.deductionPeriodMonth !== ""
                    ? data.deductionPeriodMonth
                    : null,
                formList: currentFileList,
                screenId: "SCRR411112",
                duplicationLosYear: data?.duplicationLosYear,
                duplicationLosFrom: data?.duplicationLos?.startDate,
                duplicationLosTo: data?.duplicationLos?.endDate,
                latestApplyStatus: Status["受理待ち"],
              });

              if (res.resultCd === "I0000") {
                setState({
                  ...state,
                  errorMsgId: "",
                });
                if (
                  routerState.routerList &&
                  routerState.routerList.length >= 2
                ) {
                  navigate(
                    "" +
                      routerState.routerList[routerState.routerList.length - 2]
                        .href
                  );
                } else {
                  navigate("/");
                }
              } else {
                setState({
                  ...state,
                  errorMsgId: res.resultCd,
                });
              }
            } catch (error) {
              navigate("/error");
            }
          } else {
            if (routerState.routerList && routerState.routerList.length >= 2) {
              navigate(
                "" +
                  routerState.routerList[routerState.routerList.length - 2].href
              );
            } else {
              navigate("/");
            }
          }
        }

        break;
      case 1: // 削除
        let changeFileLists: FileList[] = [];
        if (type === "1") {
          if (context?.fileList!.some((file) => file.formClass === "42")) {
            //1枚目削除(2枚目あり)
            changeFileLists = context
              ?.fileList!.filter((file) => file.formClass !== "41")
              .map((file) => {
                if (file.formClass === "42") {
                  file.formClass = "41";
                }
                return file;
              });
            setBusinessState({
              common: businessState.common,
              job_35: {
                ...context,
                page1EmployedDate: context?.page2EmployedDate,
                page1RetiredDate: context?.page2RetiredDate,
                page1Kbn: context?.page2Kbn,
                page1PaymentAmt: context?.page2PaymentAmt,
                page1WithholdingAmt: context?.page2WithholdingAmt,
                page1ScAmtCity: context?.page2ScAmtCity,
                page1ScAmtPrefecture: context?.page2ScAmtPrefecture,
                page1LengthOfService: context?.page2LengthOfService,
                page2EmployedDate: undefined,
                page2RetiredDate: undefined,
                page2Kbn: undefined,
                page2PaymentAmt: undefined,
                page2WithholdingAmt: undefined,
                page2ScAmtCity: undefined,
                page2ScAmtPrefecture: undefined,
                page2LengthOfService: undefined,
                duplicationLosYear: context?.duplicationLosYear,
                duplicationLosFrom: context?.duplicationLosFrom,
                duplicationLosTo: context?.duplicationLosTo,
                deductionPeriodYear: context?.deductionPeriodYear,
                deductionPeriodMonth: context?.deductionPeriodMonth,
                fileList: changeFileLists,
              },
            });
          } else {
            //1枚目削除（2枚目は無し）
            changeFileLists =
              context?.fileList?.filter(
                (itm: any) => itm.formClass !== formClass
              ) ?? [];
            handleSetbusinessState("1", changeFileLists, true);
          }
        } else {
          //2枚目削除
          changeFileLists =
            context?.fileList?.filter(
              (itm: any) => itm.formClass !== formClass
            ) ?? [];
          handleSetbusinessState("2", changeFileLists, false);
        }

        if (routerState.routerList && routerState.routerList.length >= 2) {
          navigate(
            "" + routerState.routerList[routerState.routerList.length - 2].href
          );
        } else {
          navigate("/");
        }
        break;
    }
  };

  const handleSetbusinessState = (
    deleteType: string,
    changeFileLists: FileList[],
    duplicationDelFlg?: boolean
  ) => {
    setBusinessState({
      common: businessState.common,
      job_35: {
        ...context,
        [`page${deleteType}EmployedDate`]: undefined,
        [`page${deleteType}RetiredDate`]: undefined,
        [`page${deleteType}Kbn`]: undefined,
        [`page${deleteType}PaymentAmt`]: undefined,
        [`page${deleteType}WithholdingAmt`]: undefined,
        [`page${deleteType}ScAmtCity`]: undefined,
        [`page${deleteType}ScAmtPrefecture`]: undefined,
        [`page${deleteType}LengthOfService`]: undefined,
        duplicationLosYear: duplicationDelFlg
          ? undefined
          : context?.duplicationLosYear,
        duplicationLosFrom: duplicationDelFlg
          ? undefined
          : context?.duplicationLosFrom,
        duplicationLosTo: duplicationDelFlg
          ? undefined
          : context?.duplicationLosTo,
        deductionPeriodYear: duplicationDelFlg
          ? undefined
          : context?.deductionPeriodYear,
        deductionPeriodMonth: duplicationDelFlg
          ? undefined
          : context?.deductionPeriodMonth,
        fileList: changeFileLists,
      },
    });
  };

  return (
    <Box data-testid="SCRR411112test" className="SCRR411112">
      <TkStepper
        steps={stepper}
        savaStep={context?.tempSaveStep}
        activeStep={activeStep}
      />
      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        submitButtonGroup={[
          { submitButtonText: "登録" },
          {
            submitButtonText: "削除",
            bypassValidation: true,
            showButton: comeForm !== "/SCRW410001",
          },
        ]}
        buttonGroup={<TkBackButton />}
        onCheckAndSubmit={handleSubmit}
      />
    </Box>
  );
};

export default SCRR411112;
